import Cover from "../../components/cover/cover";
import AddFacility from "../../components/facilities/addfacility/addfacility";
import { useLocation } from "react-router-dom";
import { getContainerClass } from "../../components/navigation/navigation";
// import Header from "../../components/header/header  ";

const AddFacilityPage = () => {
  const breadcrumb = ["Home", "Facilities", "Add Facility"];
  const location = useLocation();

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="AddFacility" />
        <div className="facilities-container">
          <AddFacility />
        </div>
      </div>
    </>
  );
};

export default AddFacilityPage;
